// extracted by mini-css-extract-plugin
export var actionButton = "_nz-0";
export var actionMenuContainer = "_nz-i";
export var bubble = "_nz-2";
export var bubbleActionMenu = "_nz-j";
export var bubbleContext = "_nz-6";
export var bubbleItems = "_nz-7";
export var customer = "_nz-3";
export var divider = "_nz-8";
export var fileList = "_nz-9";
export var hiddenComment = "_nz-o";
export var infoAbove = "_nz-a";
export var internal = "_nz-4";
export var lightActionButton = "_nz-1";
export var link = "_nz-b";
export var merchant = "_nz-5";
export var message = "_nz-c";
export var profilePicture = "_nz-e";
export var quillToolbarContainer = "_nz-f";
export var senderDate = "_nz-g";
export var senderDateCustomer = "_nz-h";
export var senderName = "_nz-d";
export var time = "_nz-k";
export var uploadedImage = "_nz-l";
export var username = "_nz-m";
export var xsmall = "_nz-n";